// dependencies
import React, { Fragment } from "react";
import { View } from "react-native";

// components
import FlexEmbed from "../FlexEmbed";
import Stack from "../Stack";

// helpers
import { videoFormatUrl } from "../../helpers/video";

type PropsType = {
  movieList: Array<{ uri: string }>;
};

const RoomMovieList: React.FunctionComponent<PropsType> = (props) => {
  const { movieList } = props;

  return (
    <>
      {movieList.map((movie, index) => {
        return (
          <Fragment key={index}>
            <FlexEmbed ratio={9 / 16}>
              <View key={index} style={{ height: "100%" }}>
                <iframe
                  src={videoFormatUrl({ url: movie.uri })}
                  width="100%"
                  height="100%"
                  frameBorder="0"
                  scrolling="no"
                  marginHeight={0}
                  marginWidth={0}
                  allowFullScreen={true}
                />
              </View>
            </FlexEmbed>
            <Stack marginTop={1} />
          </Fragment>
        );
      })}
    </>
  );
};

export default RoomMovieList;
